<template>
    <div class="pt-[20px] bg-[#ededed]">
        <div class="max-w-[1400px] w-full mx-auto">
            <div class="pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]" id="offersNavigation">
                <offerNavigation />
            </div>
        </div>
    </div>
    <div class="max-w-[1400px] w-full container mx-auto">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <div class="pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]" id="offersForm">
            <h2 class="text-left text-2xl font-medium mb-[3%]">
                <strong>Berechneter Vorschlag</strong>
            </h2>

            <v-form @submit.prevent="submit" ref="formRef">
                <h2 class="my-[2.5%] text-2xl font-normal" id="Lizenzkosten">
                    <span class="cursor-pointer" @click="showLizenzkosten = !showLizenzkosten"
                        >Lizenzkosten
                        <i
                            class="bi-chevron-down ml-[5px] text-[#db0720]"
                            v-if="showLizenzkosten"
                        ></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showLizenzkosten">
                    <FormInput
                        v-model="n_relevante_nutzer"
                        label="Anzahl relevante Nutzer"
                        @change="(e: any) => (n_relevante_nutzer = e.target.value)"
                    />

                    <template v-for="section in formFields[0]" :key="section.title">
                        <h2 class="mb-[2%] mt-5 text-xl font-normal" v-if="'title' in section">
                            {{ section.title }}
                        </h2>
                        <div class="form-section">
                            <FormInput
                                v-for="field in section.fields"
                                :key="field.label"
                                :label="field.label"
                                v-model="computedProperty(field.model).value as string"
                                :disabled="field?.disabled || false"
                                @change="
                                    (event: any) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                "
                            />
                        </div>
                    </template>
                </v-container>

                <hr />

                <h2 class="my-[2.5%] text-2xl font-normal" id="Rabattierung">
                    <span class="cursor-pointer" @click="showRabattierung = !showRabattierung"
                        >Rabattierung
                        <i
                            class="bi-chevron-down ml-[5px] text-[#db0720]"
                            v-if="showRabattierung"
                        ></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showRabattierung">
                    <template v-for="section in formFields[1]" :key="section.title">
                        <h2 class="mb-[2%] mt-5 text-xl font-normal" v-if="'title' in section">
                            {{ section.title }}
                        </h2>
                        <div class="form-section">
                            <FormInput
                                v-for="field in section.fields"
                                :key="field.label"
                                :label="field.label"
                                v-model="computedProperty(field.model).value as string"
                                :disabled="field.disabled || false"
                                @change="
                                    (event: any) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                "
                            />
                        </div>
                    </template>
                </v-container>

                <hr />

                <h2 class="my-[2.5%] text-2xl font-normal" id="Diverses">
                    <span class="cursor-pointer" @click="showDiverses = !showDiverses"
                        >Diverses
                        <i class="bi-chevron-down ml-[5px] text-[#db0720]" v-if="showDiverses"></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showDiverses">
                    <template v-for="section in formFields[2]" :key="section.title">
                        <h2 class="mb-[2%] mt-5 text-xl font-normal" v-if="'title' in section">
                            {{ section.title }}
                        </h2>
                        <div class="form-section">
                            <FormInput
                                v-for="field in section.fields"
                                :key="field.label"
                                :label="field.label"
                                v-model="computedProperty(field.model).value as string"
                                :disabled="field.disabled"
                                @change="
                                    (event: any) =>
                                        field.model
                                            ? updateProposedOfferValue(
                                                  field.model,
                                                  event.target.value
                                              )
                                            : null
                                "
                            />
                        </div>
                    </template>
                </v-container>

                <hr />

                <h2 class="my-[2.5%] text-2xl font-normal" id="Unterschriften">
                    <span class="cursor-pointer" @click="showUnterschriften = !showUnterschriften"
                        >Unterschriften
                        <i
                            class="bi-chevron-down ml-[5px] text-[#db0720]"
                            v-if="showUnterschriften"
                        ></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showUnterschriften">
                    <v-select
                        style="width: 50%; display: inline-block"
                        class="p-[5px]"
                        v-model="signed_2"
                        :items="signaturesList"
                        item-title="name"
                        item-value="id"
                        return-object
                        single-line
                    ></v-select>

                    <v-select
                        style="width: 50%; display: inline-block"
                        class="p-[5px]"
                        v-model="signed_1"
                        :items="signaturesList"
                        item-title="name"
                        item-value="id"
                        return-object
                        single-line
                    ></v-select>
                </v-container>

                <hr />

                <h2 class="my-[2.5%] text-2xl font-normal" id="Sprache">
                    <span class="cursor-pointer" @click="showLanguages = !showLanguages"
                        >Sprache
                        <i class="bi-chevron-down ml-[5px] text-[#db0720]" v-if="showLanguages"></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showLanguages">
                    <v-radio-group v-model="language" inline>
                        <v-radio class="w-25" label="Deutsch" value="DE"></v-radio>
                        <v-radio class="w-25" label="Französisch" value="FR"></v-radio>
                        <v-radio class="w-25" label="Italienisch" value="IT"></v-radio>
                        <v-radio class="w-25" label="Englisch" value="EN"></v-radio>
                    </v-radio-group>
                </v-container>

                <hr />

                <h2 class="my-[2.5%] text-2xl font-normal" id="PDF_bearbeiten">
                    <span class="cursor-pointer" @click="showPDF = !showPDF"
                        >PDF bearbeiten
                        <i class="bi-chevron-down ml-[5px] text-[#db0720]" v-if="showPDF"></i>
                        <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
                    </span>
                </h2>

                <v-container fluid v-if="showPDF">
                    <v-text-field
                        style="width: 100%; display: inline-block"
                        class="p-[5px]"
                        label="Individuelle Einleitung"
                        v-model="introduction"
                        @change="(e: any) => (introduction = e.target.value)"
                    />
                    <v-text-field
                        style="width: 100%; display: inline-block"
                        class="p-[5px]"
                        label="Individueller Leistungsumfang"
                        v-model="scope"
                        @change="(e: any) => (scope = e.target.value)"
                    />
                    <v-text-field
                        style="width: 100%; display: inline-block"
                        class="p-[5px]"
                        label="Individueller Schluss"
                        v-model="closure"
                        @change="(e: any) => (closure = e.target.value)"
                    />
                </v-container>

                <FullButton
                    id="generatePdfButton"
                    @click="submit()"
                    link=""
                    title="PDF generieren >"
                    width="100"
                    colour="red"
                />
            </v-form>

            <canvas class="w-100 h-[30px]"></canvas>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import offerNavigation from '@/components/SubNavigations/TheOfferNavigation.vue'
    import { ref } from 'vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import useOfferStore from '@/utils/useOfferStore'
    import { useRoute } from 'vue-router'
    import FormInput from '@/components/Offers/FormInput.vue'
    import { computed } from 'vue'
    import formFieldsJSON from '@/components/Offers/TheProposedOfferFormFields.json'
    import { Signature } from '@/model/types'
    import router from '@/router'

    const { proposedOffer, generatePdf, signaturesList, fetchSignaturesList } = useOfferStore()
    const route = useRoute()

    async function fetchDataOnMounted() {
        await fetchSignaturesList()
        if (Object.keys(proposedOffer.value as object).length === 0) {
            router.push('/offers')
        }
    }

    fetchDataOnMounted()

    // default visibility of menus

    const formFields = ref(formFieldsJSON.formFields)
    const showLizenzkosten = ref(true)
    const showRabattierung = ref(true)
    const showDiverses = ref(true)
    const showUnterschriften = ref(true)
    const showLanguages = ref(true)
    const language = ref('DE')
    const showPDF = ref(true)

    // custom signatures

    let signed_2 = ref<Signature>({ id: 0, name: 'Unterschrift links' })
    let signed_1 = ref<Signature>({ id: 0, name: 'Unterschrift rechts' })

    // form fields refs

    let n_relevante_nutzer = ref(proposedOffer.value?.n_relevante_nutzer || '')
    let rabatt_bisher_n_nutzer_rabattzone = ref(
        proposedOffer.value?.rabatt_bisher?.n_nutzer_rabattzone || ''
    )
    let rabatt_bisher_stufe = ref(proposedOffer.value?.rabatt_bisher?.stufe || '')
    let rabatt_bisher_betrag = ref(proposedOffer.value?.rabatt_bisher?.betrag || '')
    let rabatt_neu_n_nutzer_rabattzone = ref(
        proposedOffer.value?.rabatt_neu?.n_nutzer_rabattzone || ''
    )
    let rabatt_neu_stufe = ref(proposedOffer.value?.rabatt_neu?.stufe || '')
    let rabatt_neu_betrag = ref(proposedOffer.value?.rabatt_neu?.betrag || '')
    let einrichtungspreis_total = ref(proposedOffer.value?.einrichtungspreis?.total || '')
    let kosten_urg_preis_pro_nutzer = ref(proposedOffer.value?.kosten_urg?.preis_pro_nutzer || '')
    let kosten_urg_total = ref(proposedOffer.value?.kosten_urg?.total || '')
    let sockelbetrag_preis_pro_nutzer = ref(
        proposedOffer.value?.sockelbetrag?.preis_pro_nutzer || ''
    )
    let sockelbetrag_total = ref(proposedOffer.value?.sockelbetrag?.total || '')
    let introduction = ref(proposedOffer.value?.introduction || '')
    let scope = ref(proposedOffer.value?.scope || '')
    let closure = ref(proposedOffer.value?.closure || '')

    // form field computed properties

    const computedProperty = (propPath: string) => {
        if (typeof propPath !== 'string') {
            return computed(() => '')
        }

        const pathParts = propPath.split('.')
        return computed({
            get: () => {
                let currentValue = proposedOffer.value
                for (const part of pathParts) {
                    if (currentValue === null || currentValue === undefined) {
                        return ''
                    }
                    currentValue = currentValue[part]
                }
                return currentValue
            },
            set: (newValue) => {
                let currentValue = proposedOffer.value
                for (let i = 0; i < pathParts.length - 1; i++) {
                    const part = pathParts[i]
                    if (currentValue && currentValue[part] === undefined) {
                        currentValue[part] = {}
                    }
                    if (currentValue !== null && currentValue !== undefined) {
                        currentValue = currentValue[part]
                    }
                }
                if (currentValue !== null && currentValue !== undefined) {
                    currentValue[pathParts[pathParts.length - 1]] = newValue
                }
            },
        })
    }

    n_relevante_nutzer = computedProperty('n_relevante_nutzer')
    rabatt_bisher_n_nutzer_rabattzone = computedProperty('rabatt_bisher.n_nutzer_rabattzone')
    rabatt_bisher_stufe = computedProperty('rabatt_bisher.stufe')
    rabatt_bisher_betrag = computedProperty('rabatt_bisher.betrag')
    rabatt_neu_n_nutzer_rabattzone = computedProperty('rabatt_neu.n_nutzer_rabattzone')
    rabatt_neu_stufe = computedProperty('rabatt_neu.stufe')
    rabatt_neu_betrag = computedProperty('rabatt_neu.betrag')
    einrichtungspreis_total = computedProperty('einrichtungspreis.total')
    kosten_urg_preis_pro_nutzer = computedProperty('kosten_urg.preis_pro_nutzer')
    kosten_urg_total = computedProperty('kosten_urg.total')
    sockelbetrag_preis_pro_nutzer = computedProperty('sockelbetrag.preis_pro_nutzer')
    sockelbetrag_total = computedProperty('sockelbetrag.total')
    introduction = computedProperty('introduction')
    scope = computedProperty('scope')
    closure = computedProperty('closure')

    // functions defined and used here

    const updateProposedOfferValue = (propPath: string, newValue: any) => {
        if (typeof propPath !== 'string') {
            return
        }

        const pathParts = propPath.split('.')
        let currentValue = proposedOffer.value
        for (let i = 0; i < pathParts.length - 1; i++) {
            const part = pathParts[i]
            if (!currentValue || !currentValue[part]) {
                if (currentValue && currentValue[part] === undefined) {
                    currentValue[part] = {}
                }
            }
            if (currentValue !== null && currentValue !== undefined) {
                currentValue = currentValue[part]
            }
        }
        if (currentValue !== null && currentValue !== undefined) {
            currentValue[pathParts[pathParts.length - 1]] = newValue
        }
    }

    // TODO: There must be a simpler / more mainstream way

    const transformPayloadForPdf = (offer: any): any => {
        return {
            EDU_BASIC: {
                preis_pro_nutzer: offer.EDU_BASIC?.preis_pro_nutzer || '0',
                preis_pro_vzae: offer.EDU_BASIC?.preis_pro_vzae || '0',
                total: offer.EDU_BASIC?.total ?? 0,
            },
            EDU_SWISS: {
                preis_pro_nutzer: offer.EDU_SWISS?.preis_pro_nutzer || '0',
                preis_pro_vzae: offer.EDU_SWISS?.preis_pro_vzae || '0',
                total: offer.EDU_SWISS?.total ?? 0,
            },
            argumente: offer.argumente || [],
            einrichtungspreis: {
                total: offer.einrichtungspreis?.total ? Number(offer.einrichtungspreis.total) : 0,
            },
            error_code: offer.error_code !== undefined ? offer.error_code : null,
            error_details: offer.error_details || null,
            git_revision: offer.git_revision !== undefined ? Number(offer.git_revision) : 0,
            kosten_urg: {
                preis_pro_nutzer: offer.kosten_urg?.preis_pro_nutzer || '0',
                total: offer.kosten_urg?.total ? Number(offer.kosten_urg.total) : 0,
            },
            n_fte: offer.n_fte !== undefined ? Number(offer.n_fte) : 0,
            n_lehrende_dozierende:
                offer.n_lehrende_dozierende !== undefined ? Number(offer.n_lehrende_dozierende) : 0,
            n_lernende_studierende:
                offer.n_lernende_studierende !== undefined
                    ? Number(offer.n_lernende_studierende)
                    : 0,
            n_nutzer_korrektur:
                offer.n_nutzer_korrektur !== undefined ? Number(offer.n_nutzer_korrektur) : 0,
            n_relevante_nutzer:
                offer.n_relevante_nutzer !== undefined ? Number(offer.n_relevante_nutzer) : 0,
            n_vollzeitaequivalente:
                offer.n_vollzeitaequivalente !== undefined
                    ? Number(offer.n_vollzeitaequivalente)
                    : 0,
            preisfunktion: offer.calculator_function || '',
            rabatt_bisher: {
                betrag: offer.rabatt_bisher?.betrag || '',
                n_nutzer_rabattzone: offer.rabatt_bisher?.n_nutzer_rabattzone || '',
                stufe: offer.rabatt_bisher?.stufe || '',
            },
            rabatt_neu: {
                betrag: offer.rabatt_neu?.betrag || '',
                n_nutzer_rabattzone: offer.rabatt_neu?.n_nutzer_rabattzone || '',
                stufe: offer.rabatt_neu?.stufe || '',
            },
            regulaerer_preis: {
                preis_pro_nutzer: offer.regulaerer_preis?.preis_pro_nutzer || '0',
                preis_pro_vzae: offer.regulaerer_preis?.preis_pro_vzae || '0',
                total:
                    offer.regulaerer_preis?.total !== undefined
                        ? Number(offer.regulaerer_preis.total)
                        : 0,
            },
            richtpreis: {
                preis_pro_nutzer: offer.richtpreis?.preis_pro_nutzer || '0',
                preis_pro_vzae: offer.richtpreis?.preis_pro_vzae || '0',
                total: offer.richtpreis?.total !== undefined ? Number(offer.richtpreis.total) : 0,
            },
            schultyp: offer.school_type || '',
            sockelbetrag: {
                preis_pro_nutzer: offer.sockelbetrag?.preis_pro_nutzer || '0',
                total:
                    offer.sockelbetrag?.total !== undefined ? Number(offer.sockelbetrag.total) : 0,
            },
            status: offer.status || '',
            zeitstempel: offer.calculator_timestamp || new Date().toISOString(),
            contact_id: offer.contact_id !== undefined ? Number(offer.contact_id) : 0,
            offer_id: offer.offer_id !== undefined ? Number(offer.offer_id) : 0,
            introduction: offer.introduction || '',
            scope: offer.scope || '',
            closure: offer.closure || '',
            responsible_1: offer.responsible_1 !== undefined ? Number(offer.responsible_1) : 0,
            responsible_2: offer.responsible_2 !== undefined ? Number(offer.responsible_2) : 0,
            language: offer.language || 'DE',
        }
    }

    function submit() {
        proposedOffer.value = {
            ...proposedOffer.value,
            n_relevante_nutzer: n_relevante_nutzer.value,
            rabatt_bisher: {
                n_nutzer_rabattzone: rabatt_bisher_n_nutzer_rabattzone.value,
                stufe: rabatt_bisher_stufe.value,
                betrag: rabatt_bisher_betrag.value,
            },
            rabatt_neu: {
                n_nutzer_rabattzone: rabatt_neu_n_nutzer_rabattzone.value,
                stufe: rabatt_neu_stufe.value,
                betrag: rabatt_neu_betrag.value,
            },
            einrichtungspreis: {
                total: einrichtungspreis_total.value,
            },
            kosten_urg: {
                preis_pro_nutzer: kosten_urg_preis_pro_nutzer.value,
                total: kosten_urg_total.value,
            },
            sockelbetrag: {
                preis_pro_nutzer: sockelbetrag_preis_pro_nutzer.value,
                total: sockelbetrag_total.value,
            },
            introduction: introduction.value,
            scope: scope.value,
            closure: closure.value,
        }

        // Set responsible persons and language as you already do
        proposedOffer.value.responsible_2 = signed_2.value.id ? signed_2.value.id : 5169
        proposedOffer.value.responsible_1 = signed_1.value.id ? signed_1.value.id : 2
        proposedOffer.value.language = language.value

        // Transform the payload to exactly match what the PDF endpoint expects
        const pdfPayload = transformPayloadForPdf(proposedOffer.value)

        generatePdf({
            proposedOffer: { data: pdfPayload },
            offerId: proposedOffer.value.offer_id,
            contactId: Number(route.params.id),
        })
    }

    //breadcrumbs

    const breadcrumbs = [
        {
            title: 'Offerten',
            disabled: false,
            href: '/offers',
        },
        {
            title: 'Kontakt auswählen',
            disabled: false,
            href: '/offers/selectcontacts',
        },
        {
            title: 'Parameter eingeben',
            disabled: true,
            href: '/offers/createoffer/',
        },
        {
            title: 'Berechnete Offerte',
            disabled: true,
            href: '/offers/calculateprice/',
        },
    ]
</script>
